import { protectedResources } from "../config/authConfig.js";
import { User } from "../types/user.js";
import { getToken, _fetch } from "./apiHelper.js";

export const validateLC = async (userDTO : User) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(userDTO),
  };

  return _fetch(protectedResources.api.user + "/validate/lcEmail", options);
};
